import { WingsProps } from '../../Wings/Wings';
import React from 'react';
import { UseAds } from '../../hooks/useContentfulAds';

export abstract class WingsTransformer {
  static toWingsProps = (wings?: UseAds['wings']): WingsProps => {
    return {
      leftWing: wings?.leftWing
        ? {
            name: wings?.leftWing?.fields?.bannerName ?? '',
            destinationUrl: wings?.leftWing?.fields?.urllink ?? '',
            image: (
              <img
                src={wings?.leftWing?.fields?.desktopImage?.fields?.file?.url}
                alt={wings?.leftWing?.fields?.bannerName}
                loading="eager"
              />
            ),
          }
        : undefined,
      rightWing: wings?.rightWing
        ? {
            name: wings?.rightWing?.fields?.bannerName ?? '',
            brand: wings?.rightWing?.fields?.brand ?? '',
            destinationUrl: wings?.rightWing?.fields?.urllink ?? '',
            image: (
              <img
                src={wings?.rightWing?.fields?.desktopImage?.fields?.file?.url}
                alt={wings?.rightWing?.fields?.bannerName}
                loading="eager"
              />
            ),
          }
        : undefined,
      trackingData: {
        campaignName: wings?.campaignName,
        campaignStartDate: wings?.campainStartDate ?? '',
        category: wings?.category,
        isBranded: !!(wings?.leftWing?.fields?.isExternal || wings?.rightWing?.fields?.isExternal),
      },
    };
  };
}
